/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AttestationReponse,
  UndisbursedChallenges,
} from '../models';
import {
    AttestationReponseFromJSON,
    AttestationReponseToJSON,
    UndisbursedChallengesFromJSON,
    UndisbursedChallengesToJSON,
} from '../models';

export interface GetChallengeAttestationRequest {
    challengeId: string;
    oracle: string;
    specifier: string;
    userId: string;
}

export interface GetUndisbursedChallengesRequest {
    offset?: number;
    limit?: number;
    userId?: string;
    completedBlocknumber?: number;
    challengeId?: string;
}

export interface GetUndisbursedChallengesForUserRequest {
    userId: string;
    offset?: number;
    limit?: number;
    completedBlocknumber?: number;
    challengeId?: string;
}

/**
 * 
 */
export class ChallengesApi extends runtime.BaseAPI {

    /**
     * @hidden
     * Produces an attestation that a given user has completed a challenge, or errors.
     */
    async getChallengeAttestationRaw(params: GetChallengeAttestationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AttestationReponse>> {
        if (params.challengeId === null || params.challengeId === undefined) {
            throw new runtime.RequiredError('challengeId','Required parameter params.challengeId was null or undefined when calling getChallengeAttestation.');
        }

        if (params.oracle === null || params.oracle === undefined) {
            throw new runtime.RequiredError('oracle','Required parameter params.oracle was null or undefined when calling getChallengeAttestation.');
        }

        if (params.specifier === null || params.specifier === undefined) {
            throw new runtime.RequiredError('specifier','Required parameter params.specifier was null or undefined when calling getChallengeAttestation.');
        }

        if (params.userId === null || params.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter params.userId was null or undefined when calling getChallengeAttestation.');
        }

        const queryParameters: any = {};

        if (params.oracle !== undefined) {
            queryParameters['oracle'] = params.oracle;
        }

        if (params.specifier !== undefined) {
            queryParameters['specifier'] = params.specifier;
        }

        if (params.userId !== undefined) {
            queryParameters['user_id'] = params.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read"]);
        }

        const response = await this.request({
            path: `/challenges/{challenge_id}/attest`.replace(`{${"challenge_id"}}`, encodeURIComponent(String(params.challengeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttestationReponseFromJSON(jsonValue));
    }

    /**
     * Produces an attestation that a given user has completed a challenge, or errors.
     */
    async getChallengeAttestation(params: GetChallengeAttestationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AttestationReponse> {
        const response = await this.getChallengeAttestationRaw(params, initOverrides);
        return await response.value();
    }

    /**
     * @hidden
     * Get all undisbursed challenges
     */
    async getUndisbursedChallengesRaw(params: GetUndisbursedChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UndisbursedChallenges>> {
        const queryParameters: any = {};

        if (params.offset !== undefined) {
            queryParameters['offset'] = params.offset;
        }

        if (params.limit !== undefined) {
            queryParameters['limit'] = params.limit;
        }

        if (params.userId !== undefined) {
            queryParameters['user_id'] = params.userId;
        }

        if (params.completedBlocknumber !== undefined) {
            queryParameters['completed_blocknumber'] = params.completedBlocknumber;
        }

        if (params.challengeId !== undefined) {
            queryParameters['challenge_id'] = params.challengeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read"]);
        }

        const response = await this.request({
            path: `/challenges/undisbursed`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UndisbursedChallengesFromJSON(jsonValue));
    }

    /**
     * Get all undisbursed challenges
     */
    async getUndisbursedChallenges(params: GetUndisbursedChallengesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UndisbursedChallenges> {
        const response = await this.getUndisbursedChallengesRaw(params, initOverrides);
        return await response.value();
    }

    /**
     * @hidden
     * Get all undisbursed challenges for a user
     */
    async getUndisbursedChallengesForUserRaw(params: GetUndisbursedChallengesForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UndisbursedChallenges>> {
        if (params.userId === null || params.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter params.userId was null or undefined when calling getUndisbursedChallengesForUser.');
        }

        const queryParameters: any = {};

        if (params.offset !== undefined) {
            queryParameters['offset'] = params.offset;
        }

        if (params.limit !== undefined) {
            queryParameters['limit'] = params.limit;
        }

        if (params.completedBlocknumber !== undefined) {
            queryParameters['completed_blocknumber'] = params.completedBlocknumber;
        }

        if (params.challengeId !== undefined) {
            queryParameters['challenge_id'] = params.challengeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/challenges/undisbursed/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(params.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UndisbursedChallengesFromJSON(jsonValue));
    }

    /**
     * Get all undisbursed challenges for a user
     */
    async getUndisbursedChallengesForUser(params: GetUndisbursedChallengesForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UndisbursedChallenges> {
        const response = await this.getUndisbursedChallengesForUserRaw(params, initOverrides);
        return await response.value();
    }

}
